export class WebAPI {
  /**
   * .envのREACT_APP_WEBAPIに設定されているWebAPIのURL
   */
  static readonly ROOT = process.env.REACT_APP_WEBAPI;

  static readonly ETAG = "etag=";

  static readonly PROJECTS = WebAPI.ROOT + "projects";
  static readonly GET_PROJECTS = WebAPI.PROJECTS;
  static readonly CREATE_PROJECT = WebAPI.PROJECTS;
  static UPDATE_PROJECT(projectid: string, etag?: string): string {
    let url = WebAPI.PROJECTS + "/" + projectid;
    if (etag && etag.length > 0) {
      url = url + "?" + this.ETAG + etag;
    }
    return url;
  }
  static DELETE_PROJECT(projectid: string, etag?: string): string {
    let url = WebAPI.PROJECTS + "/" + projectid;
    if (etag && etag.length > 0) {
      url = url + "?" + this.ETAG + etag;
    }
    return url;
  }
  static COPY_PROJECT(projectid: string, etag?: string): string {
    let url = WebAPI.PROJECTS + "/" + projectid + "/copy";
    if (etag && etag.length > 0) {
      url = url + "?" + this.ETAG + etag;
    }
    return url;
  }

  static readonly PARAM_PROJECTID = "?projectid=";

  static readonly FILES = WebAPI.ROOT + "files";
  static readonly DATAFILES = WebAPI.ROOT + "files/data";
  static GET_DATAFILES(projectid: string): string {
    return (
      WebAPI.DATAFILES + this.PARAM_PROJECTID + projectid
    );
  }
  static GET_DATAFILE(projectid: string, fileid: string): string {
    return (
      WebAPI.DATAFILES +
      "/" +
      fileid +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static DELETE_DATAFILE(projectid: string, fileid: string): string {
    return (
      WebAPI.DATAFILES +
      "/" +
      fileid +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static UPLOAD_DATAFILE(projectid: string): string {
    return (
      WebAPI.DATAFILES +
      "/raw" +
      this.PARAM_PROJECTID +
      projectid
    );
  }

  static readonly CONFFILES = WebAPI.ROOT + "files/conf";
  static GET_CONFFILE(projectid: string, type: string): string {
    return (
      WebAPI.CONFFILES +
      "/" +
      type +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static DELETE_CONFFILE(projectid: string, type: string): string {
    return (
      WebAPI.CONFFILES +
      "/" +
      type +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static UPLOAD_CONFFILE(projectid: string, type: string): string {
    return (
      WebAPI.CONFFILES +
      "/" +
      type +
      "/raw" +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static DOWNLOAD_CONFFILE(projectid: string, type: string): string {
    return (
      WebAPI.CONFFILES +
      "/" +
      type +
      "/raw" +
      this.PARAM_PROJECTID +
      projectid
    );
  }

  static readonly SIMULATOR = WebAPI.ROOT + "simulator";
  static CREATE_SIMULATOR(projectid: string): string {
    return (
      WebAPI.SIMULATOR + this.PARAM_PROJECTID + projectid
    );
  }
  static GET_SIMULATOR(projectid: string): string {
    return (
      WebAPI.SIMULATOR + this.PARAM_PROJECTID + projectid
    );
  }
  static DELETE_SIMULATOR(projectid: string, simulatorid: string): string {
    return (
      WebAPI.SIMULATOR +
      "/" +
      simulatorid +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static SIMULATION_SIMULATOR(projectid: string): string {
    return (
      WebAPI.SIMULATOR +
      "/simulation" +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static GETRESULT_SIMULATOR(projectid: string): string {
    return (
      WebAPI.SIMULATOR +
      "/simulation" +
      this.PARAM_PROJECTID +
      projectid
    );
  }

  static readonly MODELS = WebAPI.ROOT + "models";
  static readonly GETREV_MODEL =
    WebAPI.MODELS + "/revision";
  static TRAIN_MODEL(projectid: string): string {
    return (
      WebAPI.MODELS + this.PARAM_PROJECTID + projectid
    );
  }
  static DELETE_MODEL(projectid: string): string {
    return (
      WebAPI.MODELS +
      "/progress" +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static GETCONFIG_MODEL(projectid: string): string {
    return (
      WebAPI.MODELS +
      "/config" +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static EVALUATION_MODEL(projectid: string): string {
    return (
      WebAPI.MODELS +
      "/evaluation" +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static GET_EVALUATION(projectid: string, modelid: string): string {
    return (
      WebAPI.MODELS +
      "/evaluation/" +
      modelid +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static DOWNLOAD_FKDPPMODEL(projectid: string, modelid: string): string {
    return (
      WebAPI.MODELS +
      "/" +
      modelid +
      "/raw" +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static GETFKDPPCONF_MODEL(projectid: string, modelid: string): string {
    return (
      WebAPI.MODELS +
      "/" +
      modelid +
      "/fkdppconf" +
      this.PARAM_PROJECTID +
      projectid
    );
  }
  static SIMULATION_MODEL(projectid: string): string {
    return (
      WebAPI.MODELS +
      "/simulation" +
      this.PARAM_PROJECTID +
      projectid
    );
  }

  static readonly NOTICES = WebAPI.ROOT + "notices";
  static readonly GET_NOTICES_COUNTS =
    WebAPI.NOTICES + "/counts";
  static readonly SET_NOTICES_READ =
    WebAPI.NOTICES + "/setread";

  static readonly LICENCES = WebAPI.ROOT + "licences";
  static readonly REGIST_MACADDR =
    WebAPI.LICENCES + "/macaddr";
  static readonly REGIST_CODE = WebAPI.LICENCES + "/code";
  static readonly REGIST_TERM =
    WebAPI.LICENCES + "/termcode";
  static UPDATE_MACADDR(macaddr: string) {
    //return this.REGIST_MACADDR + "/" + macaddr;
    return this.LICENCES + "/macaddr/" + macaddr;
  }

  /**
   * token有効期限切れhttpステータス
   */
  static readonly STATUS_BAD_TOKEN = 401;

  /**
   * httpステータスが存在しない場合のメッセージID
   */
  static readonly ID_SYSTEM_ERROR = "err_api_system_error";
  /**
   * ファイル件数が最大値を超える場合のメッセージID
   * ローカル判定用
   */
  static readonly ID_NUM_FILE_EXCEED = "err_api_num_file_exceed";
  /**
   * ファイルサイズが最大値を超える場合のメッセージID
   * ローカル判定用
   */
  static readonly ID_FILE_TOO_LARGE = "err_api_file_too_large";
  /**
   * ファイル名が重複している場合のメッセージID
   * ローカル判定用
   */
  static readonly ID_FILE_NAME_DUP = "err_api_file_name_dup";
}

export interface IFailCallbackParam {
  /**
   * WebAPIエラーの場合に呼び出されます
   * @callback fail
   * @param {string | undefined} id - メッセージID、致命的なエラーの場合はundefined
   * @param {number | undefined} status - httpステータスが存在ずる場合はhttpステータス、存在しない場合はundefined
   */
  fail: (id: string | undefined, status: number | undefined) => void;
}

export interface ISelectProjectParam {
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * ETAG
   */
  etag?: string;
}

export interface ISelectSimulatorParam {
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * シミュレータID
   */
  simulatorid: string;
}

/**
 * any型
 */
// eslint-disable-next-line
export type AnyType = any;

/**
 * チャート行データ
 */
export type ChartRowData = AnyType[];

/**
 * チャート行データ配列
 */
export type ChartRowDataArray = ChartRowData[];
